import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './crm-ui.scss';

function CrmCard({
  title,
  subtitle,
  actions,
  children,
  collapsible = false,
  defaultCollapsed = false,
  collapsed: controlledCollapsed,
  onCollapsedChange,
  className = '',
  bodyClassName = '',
}) {
  const [localCollapsed, setLocalCollapsed] = useState(defaultCollapsed);
  const collapsed = controlledCollapsed ?? localCollapsed;

  const toggle = () => {
    const next = !collapsed;
    if (controlledCollapsed === undefined) setLocalCollapsed(next);
    onCollapsedChange?.(next);
  };

  return (
    <section className={`crm-card ${className}`.trim()}>
      {title || subtitle || actions || collapsible ? (
        <header className="crm-card__header">
          <div className="crm-card__heading">
            {collapsible ? (
              <button
                type="button"
                className="crm-card__collapse"
                onClick={toggle}
                aria-expanded={!collapsed}
              >
                <ExpandMoreIcon className={collapsed ? 'is-collapsed' : ''} aria-hidden="true" />
                <span className="crm-card__title">{title}</span>
              </button>
            ) : (
              title ? <h3 className="crm-card__title">{title}</h3> : null
            )}
            {subtitle ? <p className="crm-card__subtitle">{subtitle}</p> : null}
          </div>
          {actions ? <div className="crm-card__actions">{actions}</div> : null}
        </header>
      ) : null}
      {!collapsed ? <div className={`crm-card__body ${bodyClassName}`.trim()}>{children}</div> : null}
    </section>
  );
}

export default CrmCard;
